const settings = {
  fetchDebounceTimeout: 3000,
  tiers: ['acme-basic', 'acme-premier', 'acme-hab'], // order is important (from low to high)
};
export default settings;
